import React from 'react'

import Container from 'components/atoms/Container'
import Typography from 'components/atoms/Typography'
import MailSvg from 'components/atoms/SVGIcons/Mail'
import FacebookSvg from 'components/atoms/SVGIcons/Facebook'
import InstagramSvg from 'components/atoms/SVGIcons/Instagram'
import WhatsappSvg from 'components/atoms/SVGIcons/Whatsapp'
import TwitterSvg from 'components/atoms/SVGIcons/Twitter'
import YoutubeSvg from 'components/atoms/SVGIcons/Youtube'
import CallCenterSvg from 'components/atoms/SVGIcons/CallCenter'

import getLinkAttr from 'utils/getLinkAttr'
import Relazsizes from 'relazsizes'

import config from 'config'

const { assets_url: assetsUrl } = config

const SocialMedia = () => (
  <div className="new-footer__social-media">
    <a href="https://www.instagram.com/quippercampus/" >
      <div className="new-footer__icon-socmed">
        <InstagramSvg fill="#fff"/>
      </div>
    </a>
    <a href="https://www.facebook.com/quippercampus/" >
      <div className="new-footer__icon-socmed">
        <FacebookSvg fill="#fff"/>
      </div>
    </a>
    <a href="https://twitter.com/quippercampus" >
      <div className="new-footer__icon-socmed">
        <TwitterSvg fill="#fff"/>
      </div>
    </a>
    <a href="https://www.youtube.com/c/QuipperVideoID/" >
      <div className="new-footer__icon-socmed">
        <YoutubeSvg fill="#fff"/>
      </div>
    </a>
  </div>
)

const FooterTitle = ({ title }) => (
  <Typography variant="subbody" component="p" className="new-footer__title">
    {title}
  </Typography>
)

const FooterLink = ({ link, text }) => (
  <a href={link} className="new-footer__link" {...getLinkAttr(link)}>
    <Typography variant="caption" component="p">
      {text}
    </Typography>
  </a>
)

const Footer = () => (
  <div id="Footer" className="new-footer">
    <Container next>
      <div className="new-footer__head">
        <Relazsizes src={`${assetsUrl}/assets/img/logo/quipper_main_logo.svg`} className="new-footer__logo" />
        <Typography variant="subbody" component="span" className="new-footer__tagline">
          Panduan memilih kampus, jurusan dan karir untuk masa depanmu.
        </Typography>
        <SocialMedia />
      </div>

      <hr className="new-footer__hr" />

      <div className="new-footer__wrapper">
        <div className="new-footer__link-section">
          <div className="new-footer__list">
            <FooterTitle title="Quipper Campus" />
            <FooterLink link="https://campus.quipper.com/directory" text="Direktori" />
            <FooterLink link="https://campus.quipper.com/majors" text="Jurusan" />
            <FooterLink link="https://campus.quipper.com/careers" text="Karir" />
            <FooterLink link="https://campus.quipper.com/tests" text="Uji Potensi" />
            <FooterLink link="https://campus.quipper.com/partners" text="Mitra" />
          </div>
          <div className="new-footer__list">
            <div className="new-footer__sub-list">
              <FooterTitle title="Untuk Murid" />
              <FooterLink link="https://www.quipper.com/id/video/" text="Quipper Video" />
              <FooterLink link="https://www.quipper.com/id/school/students" text="Quipper School" />
              <FooterLink link="https://campus.quipper.com/" text="Quipper Campus" />
            </div>
            <div className="new-footer__sub-list">
              <FooterTitle title="Untuk Guru" />
              <FooterLink link="https://www.quipper.com/id/school/teachers" text="Quipper School" />
            </div>
          </div>
          <div className="new-footer__list">
            <FooterTitle title="Tentang Quipper" />
            <FooterLink link="https://www.quipper.com/id/about/" text="Quipper Indonesia" />
            <FooterLink link="https://www.quipper.com/career/Indonesia/" text="Karir" />
            <FooterLink link="https://www.quipper.com/id/blog/category/media-corner/" text="Media" />
            <FooterLink link="https://www.quipper.com/id/blog" text="Quipper Blog" />
            <FooterLink link="https://quipper.github.io" text="Tech Blog" />
          </div>
        </div>
        <div className="new-footer__list">
          <FooterTitle title="PT Quipper Edukasi Indonesia" />
          <Typography variant="caption" component="p" className="new-footer__link">
            Gedung Wirausaha, 7th floor <br /> Jalan H.R. Rasuna Said Kav. C5 <br /> Setiabudi, Jakarta, Indonesia 12920
          </Typography>

          <div className="new-footer__item-icon">
            <div className="new-footer__icon">
              <MailSvg fill="#a3b4ca"/>
            </div>
            <FooterLink
              link="mailto:quippercampus@quipper.com?subject=User%20Support:%20Inquiry_website"
              text="quippercampus@quipper.com"
            />
          </div>
          <div className="new-footer__item-icon">
            <div className="new-footer__icon">
              <WhatsappSvg fill="#a3b4ca"/>
            </div>
            <FooterLink link="https://wa.me/6285157377153" text="085157377153" />
          </div>
          <div className="new-footer__extra">
            <Typography variant="caption" component="p" className="new-footer__extra-text">
              (09.00 - 18.00)
            </Typography>
          </div>

          <Typography variant="subbody" component="p" className="new-footer__subtitle">
            Customer Service
          </Typography>
          <div className="new-footer__item-icon">
            <div className="new-footer__icon">
              <CallCenterSvg fill="#a3b4ca"/>
            </div>
            <FooterLink link="tel:+62-081197905700" text="0811 9790 5700" />
          </div>
          <div className="new-footer__item-icon">
            <div className="new-footer__icon">
              <WhatsappSvg fill="#a3b4ca"/>
            </div>
            <FooterLink link="https://wa.me/6281119027360" text="0811 1902 7360" />
          </div>
        </div>
      </div>

      <hr className="new-footer__hr" />

      <div className="new-footer__bottom-section">
        <div className="new-footer__copyright">
          <Typography variant="caption" component="p">
            {`©${new Date().getFullYear()}. All rights reserved.`}
          </Typography>
        </div>
        <div className="new-footer__bottom-content">
          <FooterLink link="https://campus.quipper.com/terms" text="Syarat & Ketentuan" />
          <FooterLink link="https://campus.quipper.com/privacy" text="Ketentuan Privasi" />
        </div>
      </div>
    </Container>
    <style jsx global>
      {`
        .new-footer {
          background-color: #0c2846;
          color: #a3b4ca;
          text-align: center;
          &__head,
          &__wrapper {
            display: flex;
            flex-direction: column;
            padding: 40px 0;
          }
          &__logo {
            margin: 0 auto 40px;
          }
          &__tagline,
          &__link>p,
          &__subtitle {
            color: #a3b4ca !important;
          }
          &__hr {
            margin: 0;
            border-top: solid 1px #1e3f6b;
          }
          &__title {
            font-weight: bold !important;
            color: #fff !important;
            margin-bottom: 24px !important;
          }
          &__subtitle {
            font-weight: bold !important;
            margin-bottom: 16px !important;
          }
          &__link {
            display: block;
            margin-bottom: 16px !important;
            p {
              line-height: 18px !important;
            }
          }
          &__item-icon,
          &__icon,
          &__bottom-section,
          &__bottom-content {
            display: flex;
            align-items: center;
            flex-direction: column;
          }
          &__list:not(:last-of-type),
          &__sub-list:first-of-type {
            margin-bottom: 40px;
          }
          &__link-section {
            margin-bottom: 24px;
          }
          &__icon {
            margin-bottom: 8px;
            width: 24px;
            height: 24px;
          }
          &__item-icon:not(:last-of-type) {
            margin-bottom: 16px;
          }
          &__extra {
            margin: -24px 0 16px 0;
          }
          &__bottom-section {
            padding: 24px 0;
          }
          &__bottom-section {
            flex-direction: column-reverse;
          }
          &__social-media {
            display: flex;
            justify-content: center;
            margin-top: 40px;
            a {
              border-radius: 50%;
              padding: 8px;
              &:first-of-type {
                background-color: #8134af;
              }
              &:nth-of-type(2) {
                background-color: #1877f2;
              }
              &:nth-of-type(3) {
                background-color: #1da1f2;
              }
              &:last-of-type {
                background-color: #ff0000;
              }
              &:not(:last-of-type) {
                margin-right: 32px;
              }
            }
          }
          &__icon-socmed {
            width: 16px;
            height: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          @media screen and (min-width: 768px) {
            text-align: left;
            &__head,
            &__wrapper,
            &__item-icon,
            &__icon,
            &__bottom-section,
            &__bottom-content {
              flex-direction: row;
            }
            &__head {
              align-items: center;
            }
            &__wrapper {
              justify-content: space-between;
            }
            &__tagline {
              font-size: 16px !important;
              line-height: 21px !important;
              flex-grow: 1;
            }
            &__logo {
              margin: 0 100px 0 0;
            }
            &__link-section {
              display: flex;
              margin-bottom: 0;
            }
            &__list {
              margin: 0;
              &:not(:last-of-type) {
                margin-right: 100px;
              }
            }
            &__link {
              &:hover {
                p {
                  text-decoration: underline;
                  color: #d3dce6 !important;
                }
              }
            }
            &__item-icon {
              .new-footer__link {
                margin: 0 !important;
              }
            }
            &__icon {
              margin: 0 16px 0 0;
            }
            &__extra {
              padding-left: 40px;
            }
            &__copyright {
              flex-grow: 1;
            }
            &__bottom-section {
              .new-footer__link {
                margin: 0 0 0 16px !important;
              }
            }
            &__social-media {
              margin-top: 0;
              a:not(:last-of-type) {
                margin-right: 16px;
              }
            }
          }
        }
      `}
    </style>
  </div>
)

export default Footer
